import { useRef } from 'react';

/*
  An id unique to one mounted SVG, for its gradients and filters: two labels or eight arcs
  on one page must not share `url(#…)` targets, or every one paints with the first's. React
  17 has no useId, so a module counter, read once per instance and kept in a ref. Base 36,
  so an id never spells a run of digits a test scans markup for.
*/
let next = 0;

export const useSvgId = (prefix: string): string => {
  const id = useRef<string>();
  if (!id.current) {
    next += 1;
    id.current = `${prefix}-${next.toString(36)}`;
  }
  return id.current;
};
